module.exports = ["cent","copy","divide","gt","lt","not","para","times"]


//////////////////
// WEBPACK FOOTER
// ./~/stringify-entities/dangerous.json
// module id = 717
// module chunks = 95715928098905 168707334958949